import {
  GamoraFoundationTask,
  GamoraFoundationTaskInput,
  assert,
  debugCreate,
} from '@ver.id/libs.internal.gamora';
const debug = debugCreate({
  namespace: 'horuz:protocols:chulak:tasks:async:tags-interval',
});

/**
 * Input
 */
export interface HoruzProtocolChulakTaskTagsIntervalInput extends GamoraFoundationTaskInput {
  callback: () => Promise<void>;
  ms: number;
}

/**
 * Polling task
 */
export class HoruzProtocolChulakTaskTagsInterval extends GamoraFoundationTask<HoruzProtocolChulakTaskTagsIntervalInput> {
  private _timer: NodeJS.Timeout | null = null;
  private _ms: number;
  private _callback: () => Promise<void>;

  constructor(input: HoruzProtocolChulakTaskTagsIntervalInput) {
    super(input);

    this._ms = input.ms;
    this._callback = input.callback;
  }

  /**
   * Start polling
   */
  override async $start(): Promise<void> {
    assert(
      this._timer === null,
      'Invalid call: $start must only be called once.',
    );

    this._timer = setInterval(() => {
      this._callback().catch((e) => {
        debug.trace(e?.message, e?.stack);
      });
    }, this._ms);
  }

  /**
   * Terminate
   */
  override async $terminate(): Promise<void> {
    if (this._timer !== null) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }
}
